import * as React from 'react';
import { SVGProps } from 'react';

const IconSectionsConnectedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10 2 6 4v10l4-2V2Z" fill="var(--color-bg-border)" />
    <path
      d="m10 2 3.447 1.724a1 1 0 0 1 .553.894v8.25a.7.7 0 0 1-1.013.625L10 12V2ZM2 3.133a.7.7 0 0 1 1.013-.626L6 4v10l-3.447-1.724A1 1 0 0 1 2 11.382v-8.25Z"
      fill="var(--color-bg-normal)"
    />
  </svg>
);
export default IconSectionsConnectedSizeS;
